import {SessionService} from '../shared/service/session.service';
import {Component, OnInit, AfterViewInit} from '@angular/core';
import {Router} from '@angular/router';

@Component({
  selector: 'app-pagenotfound',
  templateUrl: './pagenotfound.component.html',
  styleUrls: ['./pagenotfound.component.css']
})
export class PageNotFoundComponent implements OnInit, AfterViewInit {

  constructor(
    private router: Router,
    private sessionService: SessionService) {

  }

  ngOnInit() {
  }
  ngAfterViewInit(): void {

    return;
  }

  onHome() {
    if (this.sessionService.getAdminLogin()) {
      this.router.navigate(['/admin__/home'], {replaceUrl: true});
    } else {
      this.router.navigate(['/agent/home'], {replaceUrl: true});
    }
  }


}



// WEBPACK FOOTER //
// ./src/app/pagenotfound/pagenotfound.component.ts